import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

const TextQuestion = ({ question: { textArabic, textEnglish, options, order, id, answer }, setQuestionAnswer, surveyType }) => {
    const { i18n } = useTranslation();
    const [textValue, setTextValue] = useState(answer || "");

    useEffect(() => {
        setTextValue(answer || "");
    }, [id, answer]);

    const handleTextChange = (event) => {
        const value = event.target.value;
        setTextValue(value);
        // Get nextQuestionId from first option if available
        const nextQuestionId = options && options.length > 0 ? options[0].nextQuestionId : null;
        setQuestionAnswer(value, nextQuestionId);
    };

    return (
        <section className="section section-lg" style={{ padding: "10px 0" }}>
            <div className={`container rborder ${surveyType ? surveyType.toLowerCase() : ''}`}>
                <h3>
                    {order ? `${order}- ` : ""}
                    {i18n.language === "en" ? textEnglish : textArabic}
                </h3>
                <div className="number-btn-section" style={{ marginTop: "15px" }}>
                    <textarea
                        style={{ width: "100%", padding: "10px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "4px" }}
                        rows="5"
                        value={textValue}
                        onChange={handleTextChange}
                        placeholder={i18n.language === "en" ? "Enter your comments or suggestions..." : "أدخل ملاحظاتك أو اقتراحاتك..."}
                    />
                </div>
            </div>
        </section>
    );
}

export default TextQuestion;